export const AuthActionTypes = {
    LOGIN: 'LOGIN',
    LOGIN_ERROR: 'LOGIN_ERROR',
    LOGOUT: 'LOGOUT',
    SET_LOGIN: 'SET_LOGIN'
}